import {type AppDispatch, type RootState} from "../../../../store";
import { type Document } from '../../../../slices/documentSlice'
export const getUsersPOA = () => (dispatch: AppDispatch, getState: () => RootState): Document | undefined => {
    const currentUser = getState().user.currentUser
    return getState().documents.documents.find((doc) => (
        doc?.attributes?.Type?.[0]?.__component === 'documents.poa'
        && doc?.attributes?.User?.data?.id === currentUser.id
    ))
}